<template>
  <div class="box7">
    <pageTitle
      title="180天全方位、精细化、高标准陪跑"
      tit="严格督导，【按天规划具体执行动作】，快速打造高流量短视频IP带货账号！"
      titleColor="#000000"
      titColor="#333333"
    />
    <div class="content common-animation">
      <div class="item" v-for="(item, index) in list" :key="index">
        <img :src="item.img" alt="" />
        <p>{{ item.title }}</p>
        <p>{{ item.p }}</p>
      </div>
    </div>
    <div class="btn" @click="childMethod">更多课程内容</div>
  </div>
</template>

<script>
import pageTitle from "../../../components/common/pageTitle.vue";
export default {
  components: {
    pageTitle
  },
  data() {
    return {
      list: [
        {
          img: require("../../../assets/topic-page/newMedia2/box5/1.png"),
          title: "直播一对一答疑",
          color: "00ceff",
          p:
            "7-10年运营专业讲师，针对每一位学员账号问题直播一对一答疑，指导学员账号良性快速发展。"
        },
        {
          img: require("../../../assets/topic-page/newMedia2/box5/2.png"),
          title: "连麦拔高性指导",
          color: "3355ff",
          p: "百万粉丝大V（短视频运营婧姐）直播间每周1次，每次2个小时直播连麦。"
        },
        {
          img: require("../../../assets/topic-page/newMedia2/box5/3.png"),
          title: "180天全程督促",
          color: "bb33ff",
          p: "专业运营讲师按天规划具体执行动作，全程跟进、提醒学员发布作品，指导学员产出优质作品。"
        },
        {
          img: require("../../../assets/topic-page/newMedia2/box5/4.png"),
          title: "优秀案例及时分享",
          color: "ff4da6",
          p:
            "专业运营讲师时刻关注和挖掘行业优秀案例，整理优质账号（分析文档）发给学员学习。"
        },
        {
          img: require("../../../assets/topic-page/newMedia2/box5/5.png"),
          title: "每月更新行业风口",
          color: "ff4d4d",
          p: "每月更新行业新知识。"
        }
      ]
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  }
};
</script>

<style lang="scss" scoped>
.box7 {
  margin: 0 auto;
  padding: 80px 0px;
  max-width: 2048px;
  background: url("../../../assets/topic-page/newMedia2/box5/bgc.jpg")
    no-repeat;
  background-size: 2360px auto;
  background-position: top center;
  .btn{
      width: 207px;
      height: 56px;
      font-size: 20px;
      color: #fff;
      text-align: center;
      line-height: 56px;
      border-radius: 28px;
      font-weight: bold;
      box-sizing: border-box;
      box-shadow: 0 8px 7px #e2b8db;
      background: url("../../../assets/topic-page/newMedia2/btnbg1.png") no-repeat;
      cursor: pointer;
      margin: 40px auto 0;
      padding-right: 20px;
      &:hover{
        box-shadow: none;
      }
    }
  .content {
    width: 1200px;
    height: 366px;
    background-color: #ffffff;
    box-shadow: 0px 10px 20px 0px #f6edf0;
    margin: 49px auto 0;
    display: flex;
    justify-content: space-evenly;
    .item {
      width: 240px;
      height: 100%;
      padding: 50px 30px 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      position: relative;
      img {
        width: 134px;
        height: 97px;
      }
      p:nth-child(2) {
        font-size: 22px;
        font-weight: bold;
        font-stretch: normal;

        letter-spacing: 0px;
        color: #33141f;
        margin: 28px 0 17px;
      }
      p:nth-child(3) {
        font-family: PingFang-SC-Regular;
        font-size: 16px;
        line-height: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #332429;
      }
      &::after {
        content: "";
        display: block;
        background: url("../../../assets/topic-page/newMedia2/box5/line.png")
          no-repeat;
        width: 2px;
        position: absolute;
        height: 265px;
        background-size: contain;
        right: 0;
      }
      &:hover{
      background-color: #fff5f8;
      }
    }
    .item:last-child{
      &::after{
       display: none;
      }
    }
  }
}
</style>
